export default __webpack_public_path__ + "static/apple-wallet-screen-e3875417bfaac4e61834210d52a40067.png";